import { useEffect, useState } from 'react';
import { CLING_SHEET, getProcessedClingSheetUrl, loadProcessedClingSheet } from '../lib/melody/clingSprite';

export function useClingSpriteSheet(): { sheetSrc: string; ready: boolean } {
  const cached = getProcessedClingSheetUrl();
  const [sheetSrc, setSheetSrc] = useState(cached ?? CLING_SHEET.src);
  const [ready, setReady] = useState(!!cached);

  useEffect(() => {
    let cancelled = false;
    void loadProcessedClingSheet()
      .then((url) => {
        if (!cancelled) {
          setSheetSrc(url);
          setReady(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setSheetSrc(CLING_SHEET.src);
          setReady(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { sheetSrc, ready };
}
